<template>
    <div class="compare">
        <input  type="checkbox" :id="'checkbox' + stockcode" v-model="checked" @change="toggle($event)" :disabled="isDisabled" />
        <label :for="'checkbox' + stockcode">{{ compare }}</label>
    </div>
</template>
<script>
export default {
    props: {
        stockcode: {
            type: String,
            required: true
        },
        producttitle: {
            type: String,
            required: true
        },
        compare: {
            type: String,
            required: true,
            default: 'Compare'
        }
    },
    data() {
        return {
            checked: false
        };
    },
    mounted() {

        let index = this.$store.state.compare.list.findIndex(p => p.stockcode == this.stockcode);

        // console.log(this.stockcode, index);

        if(index >= 0){
            this.checked = true;
        }
    },
    methods: {
        addToCompareList() {
            this.$store.commit("wishlist/addItem", this.stockcode);
        },
        toggle($event) {

            if (this.checked === true) {

                let product = new Object();
                product['stockcode'] = this.stockcode;
                product['producttitle'] = this.producttitle;
                this.$store.commit("compare/addItem", product);

            } else {
                this.$store.commit("compare/removeItem", this.stockcode);
            }
        }
    },
    computed: {
        isDisabled: function() {
            return this.$store.state.compare.list.length >= 4 && !this.checked;
        },
        isChecked: function() {
            return this.$store.state.compare.list.length >= 4 && !this.checked;
        },
    }
};
</script>
